import { FunctionComponent, useEffect, useState } from "react"
import { useTypedDispatch } from "../../../app/store"
import { pauseTimer } from "../simulationThunks"
import { convertToTime } from "../utils"
import Modal from "../../../components/modal"

type ModalBreaktimeProps = {
  closeModalBreaktime: () => void
}

const realtimePauseIsComplete = (
  startTime: number,
  pauseTimeAllowed: number,
) => {
  return Date.now() - startTime > pauseTimeAllowed * 1000
}

const ModalBreaktime: FunctionComponent<ModalBreaktimeProps> = (props) => {
  const dispatch = useTypedDispatch()

  // Local timer (not using store). Counts down from 5 minutes.
  const pauseTimeSeconds = 5 * 60
  const [pauseStart] = useState(Date.now())
  // Keep local timer even though we could do a straight time compare
  // because we need to use ticks to update the UI.
  const [localTimer, setLocalTimer] = useState(pauseTimeSeconds)

  useEffect(() => {
    if (
      localTimer <= 0 ||
      realtimePauseIsComplete(pauseStart, pauseTimeSeconds)
    ) {
      props.closeModalBreaktime()
      return
    }
    const interval = setInterval(() => {
      setLocalTimer(localTimer - 1)
    }, 1000)
    return () => clearInterval(interval)
  }, [localTimer])

  useEffect(() => {
    dispatch(pauseTimer())
    return () => {}
  }, [])

  return (
    <Modal
      id="modalBreaktime"
      open={true}
      title="Taking a Break"
      onClose={props.closeModalBreaktime}>
      <div>
        <div className="self-stretch relative text-sm leading-[24px] text-gray-600">
          You have paused the simulation.
        </div>
        <div className="self-stretch relative text-sm leading-[24px] text-gray-600">
          The simulation will resume in:
        </div>
        <div className="text-lg font-semibold leading-[28px]">
          {convertToTime(localTimer, false)}
        </div>
      </div>
    </Modal>
  )
}

export default ModalBreaktime
